import { WikiIndexEntry } from './model'

export const wikiIndexItemsMapper = (itemsRoot: any): WikiIndexEntry =>
  itemsRoot && {
    path: itemsRoot.path,
    subPages: itemsRoot.subPages && itemsRoot.subPages.map(wikiIndexItemsMapper)
  }
